var map = {
	"./american-football-2.svg": 274,
	"./arrow-25.svg": 275,
	"./arrow-65.svg": 276,
	"./banknote-15.svg": 146,
	"./banknote-18.svg": 66,
	"./basketball-2.svg": 277,
	"./chart-21.svg": 98,
	"./check-mark-2.svg": 278,
	"./coin-9.svg": 99,
	"./game.svg": 147,
	"./help-3.svg": 279,
	"./ice-hockey-2.svg": 280,
	"./key-1.svg": 67,
	"./log-out-3.svg": 100,
	"./logo2.png": 65,
	"./messages.svg": 137,
	"./mobile.svg": 132,
	"./preloader.gif": 48,
	"./refresh-3.svg": 68,
	"./refresh.svg": 49,
	"./soccer-1.svg": 104,
	"./sort-27.svg": 281,
	"./star-1.svg": 282,
	"./star-5.svg": 283,
	"./time-17.svg": 50,
	"./trophy-8.svg": 284,
	"./user-20.svg": 97,
	"./volleyball-2.svg": 285,
	"./xlsx.svg": 105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 145;